import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import EmptyStateCard from "../../../../components/EmptyStateCard";

const EmptyClientGroups = () => {
  return (
    <Box data-testid="EmptyClientGroupsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="No client groups yet. Client groups are created automatically when you add clients to your organization."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500 }}>
          <Typography style={{ textAlign: "center" }}>
            Once you add clients, each client will automatically get their own 
            private message group for 1-on-1 conversations. Both you and your 
            client will be able to chat directly through these groups.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyClientGroups;